import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    FormControl, FormControlLabel, Typography, TextField, RadioGroup, Radio, Checkbox,
    Button, Box, FormHelperText, Autocomplete, Select, InputLabel, MenuItem, InputAdornment,
    IconButton
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Formik, useFormik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { fetchBuyersByCompanyId, fetchBuyerBusinessUnitByCompanyId, fetchSellerBusinessUnit, fetchOrdersToLink, resetShipmentState, linkUnlinkBuyerPurchaseOrder } from '../../../redux/shipmentSlice';
import linkIcon from '../../../assets/images/link.svg'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useNavigate } from 'react-router-dom';
import LinkedOrdersModalShipment from './LinkedShipmentModal'
import { ACTION } from '../../../helpers/commonName'
import { toast } from 'react-hot-toast';

dayjs.extend(localizedFormat);
const formattedDate = dayjs().format('LL');


// Create a new object with the shape of our input initial state variable.const 
const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
export const CREATE_SHIPMENT_VALIDATION = yup.object().shape({
    invoiceNumber: yup.string().required('Seller Invoice Number cannot be empty.')
    .max(100, 'Seller Invoice Number should not exceed 100 characters')
    .test('non-eng-char', 'Please enter English characters only.', (value) => !nonEngChar.test(value)),
    buyerCompanyKeyId: yup.string().required('Buyer is required.'),
    invoiceDate: yup.date().required('Invoice date is required.'),
    // sellerUnit: yup.string().required('Seller Unit is required.'),
    // buyerUnit: yup.string().required('Buyer Unit is required.'),
    // shipmentTransportMode: yup.string().required('Transport Mode is required.'),
    // shipmentDescription: yup.string().required('Order description is required.'),

})
const CreateShipment = ({ onSubmit, isLinked, setIsLinked, handleStepChange, currentStep, actionType }) => {

    const navigate = useNavigate();
    const navigateToOutboxLandingPage = () => {
        navigate("/outbox-shipment")
    }
    const handleLinkIcon = () => {
        // console.log("insideeeeee")
    }
    const dispatch = useDispatch();

    const shipmentInfo = useSelector(state =>
        state.shipment.shipmentDetails
            ? state.shipment.shipmentDetails.data
            : []);
    // console.log("shipmentInfo",shipmentInfo)
    const shipmentState = useSelector(state => state.shipment);
    const buyerList = shipmentState?.buyers?.data ? shipmentState?.buyers?.data : [];
    const buyerBusinessUnit = shipmentState?.buyerBusinessUnit ? shipmentState?.buyerBusinessUnit : [];
    const sellerBusinessUnit = shipmentState?.sellerBusinessUnit ? shipmentState?.sellerBusinessUnit : [];
    const linkedOrders = shipmentState?.linkingOrders?.data ? shipmentState?.linkingOrders?.data : [];
    const totalRecords = shipmentState?.linkingOrders?.data ? shipmentState?.linkingOrders?.totalRecords : 0;

    const [order, setOrder] = useState('');
    // console.log("ORDERRRRRRRRRRR",order);
    // const [buyerId, setBuyerId] = useState('');
    const [initialState, setInitialState] = useState({
        invoiceNumber: shipmentInfo?.invoiceNumber || '',
        invoiceDate: dayjs(shipmentInfo?.invoiceDate) || dayjs(),
        shipmentTransportMode: shipmentInfo?.shipmentTransportMode || '',
        shipmentDescription: shipmentInfo?.shipmentDescription || '',
        buyerCompanyBuId: shipmentInfo?.buyerCompany?.companyBuId || 0,
        sellerCompanyBuId: shipmentInfo?.sellerCompany?.companyBuId || 0,
        forestCompanyKeyId: shipmentInfo?.forestCompanyKeyId || 0,
        buyerCompanyKeyId: shipmentInfo?.buyerCompany?.companyId || '',
        isLinked: shipmentInfo?.isLinked || 0,
        orderNumber: shipmentInfo?.orderNumber || ''
    })
    const [buyerId, setBuyerId] = useState(initialState.buyerCompanyKeyId);
    // console.log("initialStateinitialStateinitialStateinitialStateinitialState",initialState)

    const shipment = actionType === ACTION.EDIT ? {
        invoiceNumber: shipmentInfo?.invoiceNumber || '',
        invoiceDate: dayjs(shipmentInfo?.invoiceDate) || dayjs(),
        shipmentTransportMode: shipmentInfo?.shipmentTransportMode || '',
        shipmentDescription: shipmentInfo?.shipmentDescription || '',
        buyerCompanyBuId: shipmentInfo?.buyerCompany?.companyBuId || 0,
        sellerCompanyBuId: shipmentInfo?.sellerCompany?.companyBuId || 0,
        forestCompanyKeyId: shipmentInfo?.forestCompanyKeyId || 0,
        buyerCompanyKeyId: shipmentInfo?.buyerCompany?.companyId || '',
        isLinked: shipmentInfo?.isLinked || 0,
        orderNumber: shipmentInfo?.orderNumber || ''
    } : initialState;
    // console.log("actiontyo",actionType,"shipmentttttttttttttttt",shipment)

    // const [initialState, setInitialState] = useState({
    //     invoiceDate: dayjs(),
    //     shipmentTransportMode: '',
    //     shipmentDescription: '',
    //     buyerCompanyBuId: '',
    //     sellerCompanyBuId: '',
    //     forestCompanyKeyId: '',
    //     buyerCompanyKeyId: '',
    // })         

    const [modalOpen, setModalOpen] = useState(false);
    const handleOpenModal = () => {
        // console.log("INITIALSTATE",initialState,"SHIPMENT",shipment);
        if (buyerId || shipment.buyerCompanyKeyId) {
            setModalOpen(true);
            if (buyerId) {
                dispatch(fetchOrdersToLink({ buyerCompanyKeyId: buyerId, searchText: '', pageNumber: 1, pageSize: 10, toDate: '', fromDate: '' }))
            } else {
                dispatch(fetchOrdersToLink({ buyerCompanyKeyId: shipment.buyerCompanyKeyId, searchText: '', pageNumber: 1, pageSize: 10, toDate: '', fromDate: '' }))
            }
        } else {
            toast.error('Please choose a buyer First')
        }
    }
    const handleCloseModal = () => setModalOpen(false);


    const handleLinkOrder = (order, setValues) => {
        // console.log(initialState, "Initial State")
        // console.log(order,"INSIDE handleLinkOrder");
        if (isLinked || shipment.isLinked) {
            toast.error('Please unlink the linked order first')
            return 0;
        } else {
            const shipmentId = shipmentInfo?.shipmentId;
            if (shipmentId) { // Added to link the product within the same screen if user navigates back to create shipment after creating the shipment.
                // This will also handle the link order in case of edit shipment
                dispatch(linkUnlinkBuyerPurchaseOrder({ shipmentId, orderId: order.orderid, action: 'link' }))
                    .then((response) => {
                        // console.log("RESPONSEEE:",response);
                        if (response.type === 'shipment/linkUnlinkBuyerPurchaseOrder/fulfilled') {
                            setValues(prevState => ({
                                ...prevState,
                                orderNumber: order.ordernumber,
                                isLinked: 1
                            }));
                            setOrder(order)
                            setIsLinked(true);
                            toast.success("Order Linked Successfully!!");
                            return 1;
                        }
                    })
                    .catch((error) => {
                        toast.error("Error occurred:", error);
                        return 0;
                    })
            } else {
                setValues(prevState => ({
                    ...prevState,
                    orderNumber: order.ordernumber,
                    isLinked: 1
                }));
                setOrder(order)
                setIsLinked(true);
                return 1;
            }
        }
        // setInitialState({...initialState, orderNumber: order.ordernumber, isLinked:1});
        // dispatch(fetchOrdersToLink({buyerCompanyKeyId: initialState.buyerCompanyKeyId, searchText:'', pageNumber:1, pageSize:10, toDate:'', fromDate:'' }))
    }

    const handleUnlinkOrder = (setValues) => {
        // console.log("INSIDE handleUnlinkLinkOrder");
        setIsLinked(false);
        setOrder(null)
        // console.log("ORDER IN HANDLEUNLINK",order);
        setValues(prevState => ({
            ...prevState,
            orderNumber: '',
            isLinked: 0
        }));
        // setInitialState({...initialState, orderNumber: '', isLinked:0});
        // dispatch(fetchOrdersToLink({buyerCompanyKeyId: initialState.buyerCompanyKeyId, searchText:'', pageNumber:1, pageSize:10, toDate:'', fromDate:'' }))
    }


    const buyerOptions = buyerList.map((buyer) => ({
        label: buyer.company_name, // Displayed in the dropdown
        value: buyer.company_key_id, // Actual value when an option is selected
    }));

    const { loading } = useSelector((state) => state.shipment);
    useEffect(() => {
        try{
        dispatch(fetchBuyersByCompanyId());
    }
    catch(err){
        console.log("Error occurred:",err)
      }
    }, [dispatch]);
    // To fetch the buyer and supplier business units
    useEffect(() => {
        // console.log("initialState.buyerCompanyKeyId",buyerId);
        // const companyId = initialState.buyerCompanyKeyId;
        // console.log("buyerId",buyerId);
        if (buyerId) {
            dispatch(fetchBuyerBusinessUnitByCompanyId({ companyId: buyerId }))
            // dispatch(fetchOrdersToLink({buyerCompanyKeyId: buyerId, searchText:'', pageNumber:1, pageSize:10, toDate:'', fromDate:'' })) // to be added in respective func
        } else {
            dispatch(fetchBuyerBusinessUnitByCompanyId({ companyId: shipment.buyerCompanyKeyId }))
        }
        dispatch(fetchSellerBusinessUnit())
        // console.log("linkedOrders",linkedOrders)
    }, [dispatch, buyerId]);

    useEffect(() => {
        // console.log("Updated sellerBusinessUnit:", sellerBusinessUnit);
    }, [sellerBusinessUnit]);

    //   const handleSellerUnitChange = (event) => {
    //     const selectedValue = event.target.value; // Get the selected value from the event
    //     const selectedOption = sellerBusinessUnit.find(option => option.companyBuName === selectedValue); // Find the corresponding option object
    //     console.log("selectedOption",selectedOption);
    //     if (selectedOption) {
    //         setInitialState({...initialState, sellerCompanyBuId:selectedOption.companyBuId, sellerCompanyBuName:selectedOption.companyBuName}); // Update the sellerbuId state with the selected option's companyBuId
    //     }
    // };

    return (
        <>

            {/* with Formik */}
            <Formik
                // initialValues={shipment}
                initialValues={shipment}
                enableReinitialize={true}
                validationSchema={CREATE_SHIPMENT_VALIDATION}
                onSubmit={(values, { setSubmitting }) => {
                    const formattedValues = {
                        ...values,
                        invoiceDate: dayjs(values.invoiceDate).format('YYYY-MM-DD'),
                        isLinked: isLinked,
                        orderId: order?.orderid
                    };
                    // console.log('Formatted Submit:', formattedValues);
                    // console.log('Values Submit:', values);
                    onSubmit(formattedValues);
                    setSubmitting(false);
                }}

            >
                {({ values, setValues, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-4 cs-form mb-3">
                                <TextField
                                    label='Seller Invoice Number *'
                                    className='md-input'
                                    name='invoiceNumber'
                                    value={values.invoiceNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.invoiceNumber}
                                    helperText={errors.invoiceNumber}
                                />
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Invoice Date *"
                                        className='md-input'
                                        value={values.invoiceDate}
                                        onChange={(newValue) => {
                                            setFieldValue('invoiceDate', newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className='md-input'
                                                error={errors.invoiceDate}
                                                helperText={errors.invoiceDate}
                                            />
                                        )}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                {/* <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className='md-input'
                            options={supplier}
                            value={values.buyerCompanyKeyId}
                            onChange={(event, newValue) => {
                                handleChange({ target: { name: 'buyerCompanyKeyId', value: newValue?.label || '' } });
                            }}
                            onBlur={handleBlur}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Supplier"
                                    error={errors.buyerCompanyKeyId}
                                    helperText={errors.buyerCompanyKeyId}
                                />
                            )}
                        /> */}
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    className='md-input'
                                    options={buyerOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    value={buyerOptions.find(option => option.value === values.buyerCompanyKeyId) || null}
                                    onChange={(event, newValue) => {
                                        handleChange({ target: { name: 'buyerCompanyKeyId', value: newValue?.value || '' } })
                                        setBuyerId(newValue?.value);
                                        // setInitialState({...initialState, buyerCompanyKeyId: newValue?.value});
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Buyer *"
                                            error={touched.buyerCompanyKeyId && Boolean(errors.buyerCompanyKeyId)}
                                            helperText={touched.buyerCompanyKeyId && errors.buyerCompanyKeyId}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <FormControl className='md-input'
                                >
                                    <InputLabel id="seller-unit">Seller Unit</InputLabel>
                                    <Select
                                        labelId="seller-unit"
                                        name="sellerCompanyBuId"
                                        value={values.sellerCompanyBuId}
                                        label="Seller Unit"
                                        onChange={(event, newValue) => {
                                            // handleChange(event);
                                            handleChange({ target: { name: 'sellerCompanyBuId', value: event.target.value || '' } })
                                            // console.log("event.target.value",event.target.value,"newValue",newValue);
                                            // setInitialState({...initialState, sellerCompanyBuId: event.target.value});
                                        }}
                                        error={errors.sellerCompanyBuId}
                                        helperText={errors.sellerCompanyBuId}
                                    >
                                        {sellerBusinessUnit.map((option) => (
                                            <MenuItem key={option.companyBuId} value={option.companyBuId}>
                                                {option.companyBuName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <FormControl className='md-input'
                                >
                                    <InputLabel id="buyer-unit">Buyer Unit </InputLabel>
                                    <Select
                                        labelId="buyer-unit"
                                        name="buyerCompanyBuId"
                                        value={values.buyerCompanyBuId}
                                        label="Buyer Unit"
                                        onChange={(event) => {
                                            handleChange(event);
                                            // console.log("event.target.value buyerCompanyBuId",event.target.value);
                                            // setInitialState({...initialState, buyerCompanyBuId: event.target.value});
                                        }}
                                        error={errors.buyerCompanyBuId}
                                        helperText={errors.buyerCompanyBuId}
                                    >
                                        {buyerBusinessUnit.map((option) => (
                                            <MenuItem key={option.companyBuId} value={option.companyBuId}>
                                                {option.companyBuName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <FormControl className='md-input'
                                >
                                    <InputLabel id="transport-mode">Transport Mode</InputLabel>
                                    <Select
                                        labelId="transport-mode"
                                        name="shipmentTransportMode"
                                        value={values.shipmentTransportMode}
                                        label="Transport Mode"
                                        onChange={handleChange}
                                        error={errors.shipmentTransportMode}
                                        helperText={errors.shipmentTransportMode}
                                    >
                                        <MenuItem value="Rail Transport">Rail Transport</MenuItem>
                                        <MenuItem value="Road Transport">Road Transport</MenuItem>
                                        <MenuItem value="Air Transport">Air Transport</MenuItem>
                                        <MenuItem value="Ship Transport">Ship Transport</MenuItem>
                                        {/* ... other units */}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-12 cs-form mb-3">
                                <TextField
                                    label='Shipment Description'
                                    className='md-input'
                                    name='shipmentDescription'
                                    multiline
                                    rows={4}
                                    value={values.shipmentDescription}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.shipmentDescription}
                                    // helperText={.errors.shipmentDescription}
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                    helperText={`${values.shipmentDescription?.length}/300`}
                                />
                            </div>
                            {/* <div className="col-md-12 cs-form mb-3  ">
                            <div className='row'> */}
                            <div className='col-md-12 mb-3'>
                                {/* <div class="input-group"> */}
                                {/* <TextField
                                style={{paddingRight: '0'}}
                                name="purchaseOrder"
                                className='form-control border-right-0'
                                label="Link Buyer Purchase Order"
                                value={values.purchaseOrder}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.purchaseOrder && Boolean(errors.purchaseOrder)}
                                helperText={touched.purchaseOrder && errors.purchaseOrder}
                                InputProps={{
                                    
                                    //  maxLength: 300,
                                    readOnly: true,
                                    endAdornment: (<InputAdornment position='end' style={{paddingRight: '0'}}> 
                                        <IconButton          color="primary"          style={{ border: '1px solid #ccc', borderRadius: '0 4px 4px 0', padding: '15px' }}         >
                                            <img src = {linkIcon} onClick = {handleLinkIcon} />
                                        </IconButton>
                                    </InputAdornment>),
                                }}
                            /> */}
                                {/* <span class="input-group-text"><img src={linkIcon} alt="Link" /></span>
                            </div> */}
                                {/* </div>
                    </div> */}
                                <div className="col-md-12 cs-form mb-3">
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        className="md-input"
                                        value={values.orderNumber}
                                        disabled={true}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        color="primary"
                                                        onClick={handleOpenModal}
                                                        component="span"
                                                    >
                                                        <span className="ms-2"><img src={linkIcon} alt="Link" /></span>
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <LinkedOrdersModalShipment
                                        open={modalOpen}
                                        onClose={handleCloseModal}
                                        orders={linkedOrders}
                                        shipment={shipment}
                                        handleLink={(order) => handleLinkOrder(order, setValues)}
                                        handleUnlink={() => handleUnlinkOrder(setValues)}
                                        shipmentId={shipmentInfo?.shipmentId}
                                        totalRecords={totalRecords}
                                    />
                                </div>
                            </div>
                            {
                                currentStep === 1 ?
                                    <div className="d-flex justify-content-between">
                                        <button type="button" className="btn btn-light grey-btn lg-btn" onClick={navigateToOutboxLandingPage}>Back</button>
                                        {/* <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
                                    Create Order
                                    
                                </Button> */}
                                        <button
                                            className="btn btn-primary greeen-btn lg-btn"
                                            type='submit'
                                            variant="contained"
                                            onClick={handleSubmit} // Use onClick to trigger form submission
                                        // disabled={ isValid || isSubmitting }
                                        >
                                            {/* Create Order */}
                                            Create
                                        </button>
                                    </div>
                                    :
                                    <></>
                            }

                            {/* <button type="submit" className="btn btn-primary greeen-btn lg-btn" disabled={loading}>
                                    {loading ? 'Submitting...' : 'Create Order'}</button>
                            </div> */}
                            {/* ... other input fields */}
                        </div>
                    </form>
                )}
            </Formik >
        </>
    )
}
export default CreateShipment